import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

function WelcomePending() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div className="login-container">
      <div className="login-card pending-card">
        <div className="pending-icon">
          <i className="fas fa-hourglass-half" />
        </div>
        <h2>Welcome, {user?.fullName || "there"}</h2>
        <p className="subtitle">
          Your account is being reviewed by an administrator.
        </p>
        <p className="pending-message">
          You will receive an email when your account is approved. Once
          approved, you will be able to access your dashboard and leads.
        </p>
        <div className="pending-actions">
          <button
            type="button"
            className="btn btn-secondary btn-block"
            onClick={() => navigate("/profile")}
          >
            <i className="fas fa-user" /> Update My Profile
          </button>
          <button
            type="button"
            className="btn btn-primary btn-block"
            onClick={handleLogout}
          >
            <i className="fas fa-sign-out-alt" /> Sign Out
          </button>
        </div>
      </div>
    </div>
  );
}

export default WelcomePending;